export const environment = {
  production: false,
  basePathUrl: 'http://212.227.243.220:8081'
  // basePathUrl: 'http://104.192.6.36:8084'
};